import Vue from 'vue'
import VueSanitize from 'vue-sanitize'
Vue.use(VueSanitize, {
  allowedTags: ['a', 'b'],
  allowedAttributes: {
    a: [ 'href' ]
  }
})
